import React from 'react';

import autoBind from 'react-autobind';

import { If, Then, Else } from 'react-if'

// import other components within the same project here
import Config from "../Config.jsx";

import Localization from "../Localization.jsx"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@material-ui/core';

import ReactHtmlParser from 'react-html-parser';

class AccountSubscriptionDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      account_subscription_status: 2,
      daysLeft: 99,
      date_end: '',
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  btnOKClicked() {
    this.setState({open: false});
    this.state.open = false;
    this.props.parent.agreementCheck();
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.ACCOUNT_SUBSCRIPTION_NOTICE}
          </DialogTitle>
          <DialogContent>
            {this.state.account_subscription_status == 1 ? 
              Localization.strings.ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_PRE + this.state.daysLeft.toString() + Localization.strings.ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_POST + this.state.date_end
              : 
              Localization.strings.ACCOUNT_SUBSCRIPTION_INACTIVE}
          </DialogContent>
          <If condition={this.state.account_subscription_status == 1}>
            <Then>
                <DialogActions style={{padding:'16px 24px'}}>
                    <Button
                    onClick={this.btnOKClicked}
                    color="primary"
                    variant="contained"
                    >
                    {Localization.strings.OK}
                    </Button>
                </DialogActions>
            </Then>
          </If>
        </Dialog>
      </div>
    )
  }
}

export default AccountSubscriptionDialog;
